export const formatDateToDisplayString = (date) => {
  const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true }
  return date instanceof Date ? date.toLocaleString('en-US', options).replace(',', '') : ''
}

export const wasDateMoreThanSomeMinutesAgo = (date, minutesAgo) => (new Date() - date) > (minutesAgo * 60 * 1000)

export const readableStringForHowLongBetweenTwoDates = (firstDate, secondDate) => {
  console.log('firstDate is', firstDate)
  console.log('secondDate is', secondDate)
  const timeDeltaMinutes = Math.floor((secondDate - firstDate) / (1000 * 60))
  const timeDeltaSeconds = Math.floor((secondDate - firstDate) / (1000))
  return timeDeltaMinutes < 2
    ? (timeDeltaSeconds + ' seconds')
    : (timeDeltaMinutes + ' minutes')
}

export const readableStringForHowLongAgoADateWas = (date) => readableStringForHowLongBetweenTwoDates(date, new Date())

export const formatUnixDateStringToDisplayString = (unixDateString) => formatDateToDisplayString(new Date(unixDateString))

export const formatDateToDisplayStringNoTime = (date) => {
  const options = { year: 'numeric', month: 'numeric', day: 'numeric' }
  return date instanceof Date ? date.toLocaleString('en-US', options).replace(',', '') : ''
}